import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Money from '../lib/Money';
import EmptyStateNoRecord from '../lib/EmptyStateNoRecord';
import Loading from '../common/Loading';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import AccountTag from '../lib/AccountTag';
import XBadge from '../lib/XBadge';
import { Button, Card, Col, Row, Table } from 'react-bootstrap';
import CardTitleContainer from '../lib/CardTitleContainer';
import Analytics from '../common/Analytics';

const GA_ACTION_NAME = "AccountPage";

const AccountAirdrops = (props) => {
    const { address } = props;
    const [ snapshot, setSnapshot ] = useState({});
    const [ error, setError ] = useState(false);
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        Analytics.event({action: GA_ACTION_NAME, category: 'AccountAirdrops'});
    }, []);

    useEffect(() => {
        setLoading(true);
        fetch(`${XRPSCAN_API_URL}/account/${address}/airdrop-midnight`)
            .then(handleResponse)
            .then((data) => {
                setSnapshot(data);
            })
            .catch((error) => {
                setError(error);
            })
            .finally(() => {
                setLoading(false);
            });
            return () => {
                setSnapshot({}); // Cleanup function
            }
    }, [address]);

    if (loading) {
        return <Loading/>;
    }

    if (!loading && (error || snapshot?.error)) {
        return (
            <EmptyStateNoRecord title="Airdrop unavailable">
                This account may not be eligible for Airdrops
            </EmptyStateNoRecord>
        )
    } else {
        return (
            <>
                <Card className='shadow-sm' border={snapshot?.eligible ? "success" : ""}>
                    <Card.Body>
                    <Card.Title>
                        <CardTitleContainer icon="snowflake-droplets" title="Midnight Glacier Drop" />
                    </Card.Title>
                    <Row>
                        <Col xs={12} md={12}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Account:</th>
                                        <th><AccountTag link>{address}</AccountTag></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Snapshot date:</td>
                                        <td>Jun 10, 2025, 11:56:41 PM UTC</td>
                                    </tr>
                                    <tr>
                                        <td>Snapshot balance:</td>
                                        <td><Money value={snapshot?.Balance}></Money></td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>
                                        <td>
                                            {snapshot?.eligible &&
                                                <XBadge variant="success">ELIGIBLE</XBadge>
                                            }
                                            {!snapshot?.eligible &&
                                                <XBadge variant="warning">NOT ELIGIBLE</XBadge>
                                            }
                                        </td>
                                    </tr>
                                    {snapshot?.eligible &&
                                    <>
                                    <tr>
                                        <td>Claim amount:</td>
                                        <td><XBadge variant="primary"><Money value={snapshot?.NIGHT} currency="NIGHT" min={0} max={6}/></XBadge></td>
                                    </tr>
                                    <tr>
                                        <td>Action:</td>
                                        <td>
                                            <Button
                                                variant="outline-info"
                                                size="sm"
                                                href="https://claim.midnight.gd/"
                                                target="_blank"
                                                rel="noopener nofollow"
                                            >Claim NIGHT &rarr;</Button>                                            
                                        </td>
                                    </tr>
                                    </>
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    </Card.Body>
                    <Card.Footer>
                        <XBadge variant="secondary" className="mr-2">DISCLAIMER</XBadge>Midnight Drop is provided and administered by the Midnight Network. XRPSCAN provides this service for your
                        information only. For further information on Midnight Drop, please contact the Midnight team.&nbsp;
                        <a href="https://www.midnight.gd/how-to-get-night" target="_blank" rel="noopener noreferrer nofollow">More information &rarr;</a>
                    </Card.Footer>

                </Card>
            </>
        )
    }
}

AccountAirdrops.propTypes = {
    address: PropTypes.string.isRequired,
}

export default AccountAirdrops;